import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'
import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/procedures/workflows' }

type Params = never
type Body = never
type Query = { hasFlow: boolean }
type Output = {
    procedures: Array<{
        id: number
        name: string
        workflows: Array<{
            id: number
            name: string
            subjectUnitTypeId: Nullable<number>
            newFeedbackCount: number
        }>
    }>
}

export type WorkflowsEndpoint = Endpoint<Params, Body, Query, Output>

export const workflowsRequest = (request: Request, args: RequestArgs<WorkflowsEndpoint>) =>
    request<WorkflowsEndpoint>(route, args)
